import { render } from "./inventorySetMenu.vue?vue&type=template&id=90a2679e&scoped=true"
import script from "./inventorySetMenu.vue?vue&type=script&lang=js"
export * from "./inventorySetMenu.vue?vue&type=script&lang=js"

import "./inventorySetMenu.vue?vue&type=style&index=0&id=90a2679e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-90a2679e"

export default script